import React, {
  useState,
  createContext,
  useEffect,
  useRef
} from 'react';

import { useSearchParams } from "react-router-dom";



import './functionalpagelogin.css';

import LeftSidebar from './leftSidebar/LeftSidebar.jsx';
import LearningPath from './learningPath/LearningPath.jsx';

import UserProfile from './leftSidebar/pages/profile/UserProfile.jsx';

import GetProCard from './rightSidebar/components/GetProCard.jsx';
import LeaderboardCard from './rightSidebar/components/LeaderboardCard.jsx';
import DailyGoalsCard from './rightSidebar/components/DailyGoalsCard.jsx';
import FooterElements from './rightSidebar/components/FooterElements.jsx';
import MotivationalMission from './rightSidebar/components/MotivationalMission.jsx';
import MotivationalClasament from './rightSidebar/components/MotivationalClasament.jsx';
import CerificateButton from './rightSidebar/components/CerificateButton.jsx';
import SocialElements from './rightSidebar/components/SocialElements.jsx';
import FollowPreviewCard from './rightSidebar/components/FollowPreviewCard.jsx';
import PWAInstallPrompt from '../../pwa/PWAInstallPrompt.jsx';
import TesteContabilitate from '../cursuri/TestConta/TesteContabilitate.jsx';


import PremiumPurchasePopup from '../../premium/PremiumPurchasePopup.jsx';

import FollowList from './leftSidebar/pages/profile/social/FollowList.jsx';

import courseConfigs from '../../config/courseConfigs.js';
import { useAuth } from '../../AuthContext';


import ContaPrimaraProgressPanel from '../cursuri/contaprimara/components/ContaPrimaraProgressPanel.jsx';

import Certificate from './leftSidebar/pages/certificates/Certificate.jsx';
import Clasament from './leftSidebar/pages/leaderboard/Clasament.jsx';
import FullLeaderboard from './leftSidebar/pages/leaderboard/FullLeaderboard.jsx';
import CoursesInPlace from './leftSidebar/pages/courses/CoursesInPlace.jsx';
import Medalii from './leftSidebar/pages/medals/Medalii.jsx';
import Misiuni from './leftSidebar/pages/missions/Misiuni.jsx';
import Profil from './leftSidebar/pages/profile/Profil.jsx';

import ContaPrimaraCourse from '../cursuri/contaprimara/ContaPrimaraCourse.jsx';
import ContaAplicataCourse
  from '../cursuri/contabilitateaplicata/ContaAplicataCourse.jsx';

import Settings from '../../settings/Settings.jsx';

export const PageNavContext =
  createContext();

const FunctionalPageLoginStart = () => {

  const { user: authUser, loading: authLoading } = useAuth();

  // ==========================================
  // PREMIUM PURCHASE POPUP
  // ==========================================

  const [
    searchParams,
    setSearchParams
  ] = useSearchParams();

  const premiumPlan =
    searchParams.get(
      "premiumPlan"
    );

  const isPremiumPopupOpen =
    premiumPlan === "monthly" ||
    premiumPlan === "three-months";

  const handleClosePremiumPopup = () => {

    const nextParams =
      new URLSearchParams(
        searchParams
      );

    nextParams.delete(
      "premiumPlan"
    );

    setSearchParams(
      nextParams,
      {
        replace: true
      }
    );

  };
  
  const [
  selectedUserId,
  setSelectedUserId
] = useState(null);

const isUserProfilePage =
  Boolean(selectedUserId);


  // ==========================================
  // REFS
  // ==========================================

  const topRef = useRef(null);

  const rightSidebarRef =
    useRef(null);

  const rightMenuRef =
    useRef(null);

  // ==========================================
  // PROFILE STATE
  // ==========================================

  const [
    profileView,
    setProfileView
  ] = useState('profile');

  const [
    followListTab,
    setFollowListTab
  ] = useState('following');

  // ==========================================
  // GENERAL STATE
  // ==========================================

  const [
    rightMenuOffset,
    setRightMenuOffset
  ] = useState(0);

  const [
    selectedMenu,
    setSelectedMenu
  ] = useState(
    isUserProfilePage
      ? 'Profil'
      : searchParams.get('menu') === 'setari'
        ? 'Setari'
        : 'Invata'
  );

  const [
    activeTab,
    setActiveTab
  ] = useState('profil');

  const [
    isAvatarEditorOpen,
    setIsAvatarEditorOpen
  ] = useState(false);

  
  // ==========================================
  // DESCHIDERE PROFIL DIN CLASAMENT
  // ==========================================

  useEffect(() => {
    const handleOpenUserProfile = (event) => {
      const userId = event.detail;

      if (userId == null) {
        return;
      }

      setSelectedUserId(userId);
      setSelectedMenu('FullLeaderboard');
      setProfileView('profile');
      setRightMenuOffset(0);

      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'instant'
      });
    };

    window.addEventListener(
      'openUserProfile',
      handleOpenUserProfile
    );

    return () => {
      window.removeEventListener(
        'openUserProfile',
        handleOpenUserProfile
      );
    };
  }, []);


  // ==========================================
  // COURSE
  // ==========================================

  const [
    selectedCourseId,
    setSelectedCourseId
  ] = useState(() => {

    const savedCourseId =
      localStorage.getItem(
        'selectedCourseId'
      );

    const parsedCourseId =
      savedCourseId
        ? Number(savedCourseId)
        : 1;

return [1, 2, 3, 4, 5].includes(
  parsedCourseId
)
      ? parsedCourseId
      : 1;
  });

  // ==========================================
  // SCROLL PAGE TO TOP
  // ==========================================

  useEffect(() => {

    if (topRef.current) {
      topRef.current.scrollIntoView({
        behavior: 'instant',
        block: 'start'
      });
    }

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'
    });

  }, []);

  // ==========================================
  // SCROLL TOP LA SCHIMBAREA USERULUI
  // ==========================================

useEffect(() => {

  if (!selectedUserId) {
    return;
  }

  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'instant'
  });

}, [selectedUserId]);

  // ==========================================
  // RIGHT MENU SCROLL
  // DOAR PENTRU INVATA
  // ==========================================

  useEffect(() => {

    if (
      selectedMenu !== 'Invata' ||
      isUserProfilePage
    ) {
      setRightMenuOffset(0);
      return;
    }

    const scroller =
      document.querySelector(
        '.line-lesson-gackground-functional'
      );

    const rightSidebar =
      rightSidebarRef.current;

    const rightMenu =
      rightMenuRef.current;

    if (
      !scroller ||
      !rightSidebar ||
      !rightMenu
    ) {
      return;
    }

    let previousScrollTop =
      scroller.scrollTop;

    const getMaxOffset = () => {

      const sidebarRect =
        rightSidebar.getBoundingClientRect();

      const menuHeight =
        rightMenu.scrollHeight;

      const bottomGap = 20;

      const availableHeight =
        window.innerHeight -
        sidebarRect.top -
        bottomGap;

      return Math.max(
        0,
        menuHeight -
        availableHeight
      );
    };

    const handleLessonScroll = () => {

      const currentScrollTop =
        scroller.scrollTop;

      const delta =
        currentScrollTop -
        previousScrollTop;

      previousScrollTop =
        currentScrollTop;

      const maxOffset =
        getMaxOffset();

      setRightMenuOffset(
        (currentOffset) => {

          const nextOffset =
            currentOffset + delta;

          return Math.max(
            0,
            Math.min(
              nextOffset,
              maxOffset
            )
          );
        }
      );
    };

    const handleResize = () => {

      const maxOffset =
        getMaxOffset();

      setRightMenuOffset(
        (currentOffset) =>
          Math.min(
            currentOffset,
            maxOffset
          )
      );
    };

    scroller.addEventListener(
      'scroll',
      handleLessonScroll,
      {
        passive: true
      }
    );

    window.addEventListener(
      'resize',
      handleResize
    );

    return () => {

      scroller.removeEventListener(
        'scroll',
        handleLessonScroll
      );

      window.removeEventListener(
        'resize',
        handleResize
      );
    };

  }, [
    selectedMenu,
    selectedCourseId,
    isUserProfilePage
  ]);

  // ==========================================
  // COURSE SELECT
  // ==========================================

  useEffect(() => {

    const handleCourseSelected = (
      event
    ) => {

      const courseId =
        Number(event.detail);

     if (
  ![1, 2, 3, 4, 5].includes(
    courseId
  )
) {
  return;
}

      setSelectedCourseId(
        courseId
      );

      localStorage.setItem(
        'selectedCourseId',
        String(courseId)
      );

      setSelectedMenu(
        'Invata'
      );

      setRightMenuOffset(0);
    };

    window.addEventListener(
      'courseSelected',
      handleCourseSelected
    );

    return () => {

      window.removeEventListener(
        'courseSelected',
        handleCourseSelected
      );
    };

  }, []);

  // ==========================================
  // COURSE ACCESS (localStorage nu e de incredere)
  // ==========================================


  // ==========================================
  // PAGE NAVIGATION
  // ==========================================

const handlePageNav = (
  menu
) => {

  setIsAvatarEditorOpen(
    false
  );

  setSelectedUserId(
    null
  );

  setSelectedMenu(
    menu
  );

  setRightMenuOffset(0);

  if (menu === 'Profil') {
    setProfileView(
      'profile'
    );
  }
};

  // ==========================================
  // ACTIVE COURSE
  // ==========================================

  // Cursurile 2-4 sunt Premium: le montam doar dupa ce profilul real confirma Premium. Altfel
  // (localStorage vechi / abonament expirat) API-ul raspunde 403 si pagina s-ar strica; pana la
  // raspunsul /user nu randam cursul, iar pentru un cont fara Premium efectul de mai sus
  // readuce selectia la cursul gratuit.

  // ==========================================
  // ACTIVE COURSE
  // TOATE CURSURILE SUNT ACCESIBILE
  // ==========================================

  const renderedCourseId = selectedCourseId;

  const activeCourseConfig =
    renderedCourseId === 2
      ? courseConfigs.financiara
      : courseConfigs.baze;

  const learnContent =
    renderedCourseId === 5 ? (
      <TesteContabilitate
        onStartTest={(variantNumber) => {
          console.log(
            'Varianta de test selectata:',
            variantNumber
          );
        }}
      />
    ) : renderedCourseId === 3 ? (
      <ContaPrimaraCourse />
    ) : renderedCourseId === 4 ? (
      <ContaAplicataCourse />
    ) : (
      <LearningPath
        courseConfig={activeCourseConfig}
      />
    );



  const isContaPrimaraCourse =
    !isUserProfilePage &&
    selectedMenu === 'Invata' &&
    renderedCourseId === 3;

  // ==========================================
  // FIXED PAGE
  // ==========================================

  const isFixedPage =
    isUserProfilePage ||
    [
      'Clasament',
       'FullLeaderboard',
      'Misiuni',
      'Certificate',
      'Profil'
    ].includes(
      selectedMenu
    );

useEffect(() => {

  if (!isFixedPage) {
    return;
  }

  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'instant'
  });

}, [
  selectedMenu,
  isFixedPage,
  selectedUserId
]);

  // ==========================================
  // CENTER COMPONENTS
  // ==========================================

  const menuComponents = {

    Invata: learnContent,

    Profil: (
      profileView ===
      'followList' ? (

       <FollowList
  initialTab={
    followListTab
  }
  onBack={() => {
    setProfileView(
      'profile'
    );
  }}
  onOpenProfile={(userId) => {
    setSelectedUserId(
      userId
    );
  }}
/>

      ) : (

    <Profil
  onMenuSelect={
    handlePageNav
  }
  onAvatarEditorChange={
    setIsAvatarEditorOpen
  }
  onOpenUser={(
    userId
  ) => {
    setSelectedUserId(
      userId
    );
  }}
/>

      )
    ),

    Certificate: (
      <Certificate />
    ),

    Clasament: (
      <Clasament />
    ),

    FullLeaderboard: (
      <FullLeaderboard />
    ),

    Medalii: (
      <Medalii />
    ),

    Misiuni: (
      <Misiuni />
    ),

    CoursesInPlace: (
      <CoursesInPlace />
    ),

Setari: (
  <Settings
    activeTab={activeTab}
    setActiveTab={setActiveTab}
    onAvatarEditorChange={setIsAvatarEditorOpen}
    onBackToProfile={() => {
      handlePageNav('Profil');
    }}
  />
)
  };

  // ==========================================
  // CURRENT CENTER CONTENT
  // ==========================================

const currentContent =
  isUserProfilePage ? (
    <UserProfile
      userId={selectedUserId}
      onBack={() => {
        setSelectedUserId(null);
      }}
    />
  ) : (
    menuComponents[
      selectedMenu
    ] || learnContent
  );

  // ==========================================
  // RIGHT MENU COMPONENTS
  // ==========================================

  const rightMenuComponents = {

    Invata: (
      <>
        <GetProCard />

        <LeaderboardCard />

        <DailyGoalsCard />

        <FooterElements />

        <SocialElements />
      </>
    ),

    Misiuni: (
      <>
        <GetProCard />

        <MotivationalMission />

        <FooterElements />

        <SocialElements />
      </>
    ),

    Clasament: (
      <>
        <GetProCard />

        <MotivationalClasament />

        <FooterElements />

        <SocialElements />
      </>
    ),

    Certificate: (
      <>
        <GetProCard />

        <CerificateButton />

        <FooterElements />

        <SocialElements />
      </>
    ),

    Profil: (
      <>
        <GetProCard />

      <FollowPreviewCard
  onOpenAll={(tab) => {
    setFollowListTab(
      tab
    );

    setProfileView(
      'followList'
    );
  }}

  onOpenUser={(userId) => {
    setSelectedUserId(
      userId
    );
  }}
/>

        <FooterElements />

        <SocialElements />
      </>
    )
  };

  // ==========================================
  // RIGHT MENU PENTRU PROFIL USER
  // ==========================================

  const userProfileRightMenu = (
    <>
      <GetProCard />

      <FollowPreviewCard
  onOpenAll={(tab) => {
    setSelectedUserId(null);

    setFollowListTab(
      tab
    );

    setProfileView(
      'followList'
    );
  }}

  onOpenUser={(userId) => {
    setSelectedUserId(
      userId
    );
  }}
/>

      <FooterElements />

      <SocialElements />
    </>
  );

  // ==========================================
  // CURRENT RIGHT MENU
  // ==========================================

  const currentRightMenu =
    isUserProfilePage
      ? userProfileRightMenu
      : (
          rightMenuComponents[
            selectedMenu
          ] || (
            <>
              <GetProCard />

              <FooterElements />

              <SocialElements />
            </>
          )
        );

  // ==========================================
  // SHOW RIGHT SIDEBAR
  // ==========================================

  const showRightSidebar =
    (
      isUserProfilePage ||
      selectedMenu !==
        'Setari'
    ) &&
    !isAvatarEditorOpen;

  // ==========================================
  // RENDER
  // ==========================================

  return (
    <PageNavContext.Provider
      value={
        handlePageNav
      }
    >

      <div
        ref={topRef}
        className={
          `functional-page-layout ${
            isFixedPage
              ? 'functional-page-layout--fixed'
              : ''
          }`
        }
      >

        {/* ================================
            LEFT SIDEBAR
        ================================ */}

        <aside
          className="functional-page-left"
        >

          <LeftSidebar
            onMenuSelect={
              handlePageNav
            }
            selectedMenu={
              isUserProfilePage
                ? 'Profil'
                : selectedMenu
            }
          />

        </aside>

        {/* ================================
            CENTER + RIGHT
        ================================ */}

        <section
          className={
            `functional-page-main ${
              isFixedPage
                ? 'functional-page-main--fixed'
                : ''
            }`
          }
        >

          <div
            className={
              `functional-page-main-inner ${
                isContaPrimaraCourse
                  ? 'functional-page-main-inner--course-layout'
                  : ''
              } ${
                selectedMenu ===
                'CoursesInPlace' &&
                !isUserProfilePage
                  ? 'functional-page-main-inner--courses'
                  : ''
              } ${
                isFixedPage
                  ? 'functional-page-main-inner--fixed'
                  : ''
              } ${
                isAvatarEditorOpen
                  ? 'functional-page-main-inner--avatar-editor'
                  : ''
              }`
            }
          >

            {/* ============================
                CENTER
            ============================ */}

            <main
              className={
                `functional-page-content ${
                  isFixedPage
                    ? 'functional-page-content--fixed'
                    : ''
                }`
              }
            >

              {currentContent}

            </main>

            {/* ============================
                RIGHT SIDEBAR
            ============================ */}

            {showRightSidebar && (

              <aside
                ref={
                  rightSidebarRef
                }
                className={
                  `functional-page-right ${
                    isContaPrimaraCourse
                      ? 'functional-page-right--course'
                      : ''
                  }`
                }
              >

                {isContaPrimaraCourse ? (

                  <ContaPrimaraProgressPanel />

                ) : (

                  <div
                    ref={
                      rightMenuRef
                    }
                    className="functional-page-right-inner"
                    style={{
                      transform:
                        selectedMenu ===
                          'Invata' &&
                        !isUserProfilePage
                          ? `translateY(-${rightMenuOffset}px)`
                          : 'translateY(0)'
                    }}
                  >

                    {currentRightMenu}

                  </div>

                )}

              </aside>

            )}

          </div>

        </section>

      </div>


       {/* ================================
          PREMIUM PURCHASE POPUP
      ================================ */}

   {isPremiumPopupOpen && (
  <PremiumPurchasePopup
    plan={premiumPlan}
    onClose={handleClosePremiumPopup}
  />
)}
{/* PWA INSTALL POPUP */}
<PWAInstallPrompt />
    </PageNavContext.Provider>






  );
};

export default FunctionalPageLoginStart;